import { render, staticRenderFns } from "./SolicitudesMusicaViva.vue?vue&type=template&id=2b3fbab8&"
import script from "./SolicitudesMusicaViva.vue?vue&type=script&lang=ts&"
export * from "./SolicitudesMusicaViva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports